import { useMyTeamsAndInvites } from "shared/teams/useMyTeams";

export function useHasMembershipForSuggestedTeam(teamId?: number) {
  const teams = useMyTeamsAndInvites({ fetchPolicy: "cache-first" });

  if (teams.data === undefined || teamId === undefined) {
    return false;
  }

  return (
    teams.data.memberships_private_details.filter((m) => m.team?.id === teamId)
      .length > 0
  );
}
